// extracted by mini-css-extract-plugin
export var orderDetails = "_qw-2";
export var orderImage = "_qw-1";
export var orderMeta = "_qw-3";
export var orderSummary = "_qw-0";
export var rightArrow = "_qw-4";